import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const submit = (e) => {
    e.preventDefault();
    window.open(`https://cliniciq.substack.com/subscribe?email=${encodeURIComponent(email.trim())}`, '_blank', 'noopener');
    setEmail('');
  };
  return (
    <form onSubmit={submit} className="flex max-w-sm overflow-hidden rounded-md border border-gray-700 focus-within:border-orange-500" data-testid="footer-newsletter-form">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email"
        className="min-w-0 flex-1 bg-gray-800 px-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none"
        data-testid="footer-newsletter-email"
      />
      <button type="submit" className="bg-orange-600 px-4 text-sm font-medium text-white transition-colors hover:bg-orange-700" data-testid="footer-newsletter-submit">
        Subscribe
      </button>
    </form>
  );
};

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 lg:gap-8">
          
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <span className="text-2xl font-bold tracking-wide">ClinicIQ</span>
            </div>
            <p className="text-gray-300 mb-4">
              Helping Canadian clinics discover, compare, and connect with healthcare technology.
            </p>
            <div className="flex items-center text-gray-300 mb-2">
              <MapPin className="w-4 h-4 mr-2" />
              <span className="text-sm">Toronto, ON, Canada</span>
            </div>
            <div className="flex items-center text-gray-300 mb-2">
              <Phone className="w-4 h-4 mr-2" />
              <span className="text-sm">1-800-CLINICIQ</span>
            </div>
            <div className="flex items-center text-gray-300">
              <Mail className="w-4 h-4 mr-2" />
              <span className="text-sm">info@cliniciq.ca</span>
            </div>
          </div>

          {/* Resources - Single Column */}
          <div>
            <h3 className="font-semibold text-lg mb-4">For Clinics</h3>
            <ul className="space-y-2">
              <li><Link to="/selection-guide" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-selection-guide">Technology Selection Guide</Link></li>
              <li><Link to="/for-vendors" className="text-gray-300 hover:text-white transition-colors">For Vendors</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About Us</Link></li>
            </ul>
          </div>

          {/* Newsletter - Substack */}
          <div>
            <h3 className="font-semibold text-lg mb-4">ClinicIQ Insights</h3>
            <p className="text-gray-300 text-sm mb-4">
              Practical insight on digital health systems in Canadian clinics—EMRs, AI, security, and workflow.
            </p>
            <NewsletterForm />
            <p className="text-xs text-gray-500 mt-2">
              Free on <a href="https://cliniciq.substack.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-300">Substack</a> · Unsubscribe anytime
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-300 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} ClinicIQ. All rights reserved.
          </div>
          <div className="flex space-x-6 text-sm">
            <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/accessibility" className="text-gray-300 hover:text-white transition-colors">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;